export default "__VITE_ASSET__hIH36t8h__"